export const RECEIVE_GET_METRICS = 'RECEIVE_GET_METRICS'
export const REQUEST_GET_METRICS = 'REQUEST_GET_METRICS'
export const FAILED_GET_METRICS = 'FAILED_GET_METRICS'
